import { Component, OnInit } from '@angular/core';
import { SessionService } from 'src/app/shared/services/session.service';
import { Location } from '@angular/common';

@Component({
  selector: 'app-acesso-negado',
  templateUrl: './acesso-negado.component.html',
  styleUrls: ['./acesso-negado.component.scss']
})
export class AcessoNegadoComponent {
  constructor(private readonly location: Location, public readonly sessionService: SessionService) {}

  back(): void {
    this.location.back();
  }
}
